import React, { useState } from 'react';

export type FormItem = { [key: string]: any };

export interface APIResponse {
    grossMonthlyCost: number;
    netMonthlyCost: number;
}
interface FormContextProps {
    form: FormItem;
		isLoading: { state: boolean; message: string };
    data: APIResponse | null;
    updateForm: (items: FormItem) => void;
		setIsLoading: (data: { state: boolean, message: string }) => void;
    updateData: (data: APIResponse) => void;
}

export const FormContext = React.createContext<FormContextProps>({
    form: {},
		isLoading: { state: false, message: '' },
		data: null,
    updateForm: (items: FormItem) => {},
		setIsLoading: (data: { state: boolean, message: string }) => {},
    updateData: (data: APIResponse) => {},
});

export const FormProvider: React.FC = ({ children }) => {
    const [form, setForm] = useState({});
		const [isLoading, setIsLoading] = useState({ state: false, message: '' });
    const [data, setData] = useState<APIResponse | null>(null);

    function updateForm(items: FormItem) {
        setForm({
            ...form,
            ...items,
        });
    }

    function updateData(info: any) {
        setData({ ...info });
    }

    return (
        <FormContext.Provider
            value={{
                isLoading,
                form,
                updateForm,
                setIsLoading,
                data,
                updateData,
            }}>
            {children}
        </FormContext.Provider>
    );
};
